module.exports = __webpack_public_path__ + "static/media/hourglass_circle_blueeaaa16fb8c355468b5f918bac7401d84.webp";